module.exports = __webpack_public_path__ + "img/description.d6823e73.svg";